import { createAction, props } from '@ngrx/store';
import {
  BaseInterface,
  ExtendedBaseInterface,
  Listing,
} from 'src/app/shared/models';

export enum ActionTypes {
  GET_ADDED_TODAY_PROPERTIES = '[Shared] Get Added Todays Properties',
  GET_ADDED_TODAY_PROPERTIES_SUCCESS = '[Shared] Get Added Todays Properties Success',
  GET_ADDED_TODAY_PROPERTIES_FAILURE = '[Shared] Get Added Todays Properties Failure',

  GET_ARIS_PRIME_PROPERTIES = '[Shared] Get Aris Prime Properties',
  GET_ARIS_PRIME_PROPERTIES_SUCCESS = '[Shared] Get Aris Prime Properties Success',
  GET_ARIS_PRIME_PROPERTIES_FAILURE = '[Shared] Get Aris Prime Properties Failure',

  GET_RECOMMENDED_PROPERTIES = '[Shared] Get Recommended Properties',
  GET_RECOMMENDED_PROPERTIES_SUCCESS = '[Shared] Get Recommended Properties Success',
  GET_RECOMMENDED_PROPERTIES_FAILURE = '[Shared] Get Recommended Properties Failure',

  SET_SHARED_DATA = '[Shared] Set Shared Data',
}

export const getAddedTodayProperties = createAction(
  ActionTypes.GET_ADDED_TODAY_PROPERTIES
);

export const getAddedTodayPropertiesSuccess = createAction(
  ActionTypes.GET_ADDED_TODAY_PROPERTIES_SUCCESS,
  props<{ data: Listing[] }>()
);

export const getAddedTodayPropertiesFailure = createAction(
  ActionTypes.GET_ADDED_TODAY_PROPERTIES_FAILURE,
  props<{ error }>()
);

export const getArisPrimeProperties = createAction(
  ActionTypes.GET_ARIS_PRIME_PROPERTIES
);

export const getArisPrimePropertiesSuccess = createAction(
  ActionTypes.GET_ARIS_PRIME_PROPERTIES_SUCCESS,
  props<{ data: Listing[] }>()
);

export const getArisPrimePropertiesFailure = createAction(
  ActionTypes.GET_ARIS_PRIME_PROPERTIES_FAILURE,
  props<{ error }>()
);

export const getRecommendedProperties = createAction(
  ActionTypes.GET_RECOMMENDED_PROPERTIES
);

export const getRecommendedPropertiesSuccess = createAction(
  ActionTypes.GET_RECOMMENDED_PROPERTIES_SUCCESS,
  props<{ data: Listing[] }>()
);

export const getRecommendedPropertiesFailure = createAction(
  ActionTypes.GET_RECOMMENDED_PROPERTIES_FAILURE,
  props<{ error }>()
);

export const setSharedData = createAction(
  ActionTypes.SET_SHARED_DATA,
  props<{ data: ExtendedBaseInterface }>()
);
